import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import StyledComponent from '~/components/Styled/Styled';

import css from './TeamChip.scss';

const TeamChip = ({ team }) => {
  const altText = `${team.medium_name} logo`;
  const shortFormName = get(team, 'abbreviation', team.short_name);

  return (
    <div className={css.gameScoreRow}>
      <span className={css.teamLogo}>
        {team.logos.small ? (
          <img src={team.logos.small} alt={altText} />
        ) : (
          <div className={css.defaultLogo} />
        )}
      </span>
      <span className={css.teamName}>{shortFormName}</span>
    </div>
  );
};

TeamChip.propTypes = {
  team: PropTypes.shape({
    short_name: PropTypes.string,
    logos: PropTypes.shape({
      small: PropTypes.string,
    }),
  }).isRequired,
};

TeamChip.displayName = 'TeamChip';

export default StyledComponent(TeamChip, [css]);
